import { faPenToSquare } from '@fortawesome/pro-light-svg-icons';

import { LabeledField } from './labeled-field.component';

import { Icon } from '@/components/ui/icon.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

interface EditableFieldProps {
  label: string;
  value: string;
  onEdit?: () => void;
  editAriaLabel?: string;
  editTestId?: string;
}

export function EditableField({ label, value, onEdit, editAriaLabel, editTestId }: EditableFieldProps) {
  return (
    <LabeledField label={label}>
      <div className="flex items-center gap-2">
        <Typography variant={TypographyVariant.BODY_TEXT} className="flex-1">
          {value}
        </Typography>
        {onEdit && (
          <button
            type="button"
            aria-label={editAriaLabel}
            data-testid={editTestId}
            className="flex items-center justify-center rounded-lg flex-shrink-0"
            onClick={onEdit}
          >
            <Icon icon={faPenToSquare} className="text-green-500 text-xl" />
          </button>
        )}
      </div>
    </LabeledField>
  );
}
